import { useSelector } from 'react-redux'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import useGetSettingFinancialStatement from '../../../financial/common/useGetSettingFinancialStatement'
import { Bank } from '../bank'
import { Corp } from '../corp'
import { Insurance } from '../insurange'
// import { Score } from '../score'
import { Securities } from '../securities'

export const Content = () => {
  const settingsFS = useGetSettingFinancialStatement()
  const { companyType } = useSelector(selectCompanyInfo)

  const renderOthers = () => {
    switch (companyType) {
      case COMPANY_TYPES.CORPORATE:
        return <Corp settingsFS={settingsFS} />

      case COMPANY_TYPES.BANK:
        return <Bank settingsFS={settingsFS} />

      case COMPANY_TYPES.NON_BANK:
      case COMPANY_TYPES.LIFE_INSURANCE:
      case COMPANY_TYPES.NON_LIFE_INSURANCE:
        return <Insurance settingsFS={settingsFS} />

      default:
        return <Securities settingsFS={settingsFS} />
    }
  }

  return (
    <>
      {/* <Score /> */}
      {renderOthers()}
    </>
  )
}
